<template>
  <div class="saved-report-filters">
    <q-select
      dense
      outlined
      :model-value="reportType"
      :options="reportTypeOptions"
      label="Тип отчета"
      data-testid="saved-report-type"
      @update:model-value="$emit('update:reportType', $event); $emit('change')"
    />
    <q-input
      dense
      outlined
      :model-value="periodFrom"
      label="С начала"
      :mask="dateInputMask"
      :rules="dateRules"
      data-testid="saved-report-period-from"
      @update:model-value="$emit('update:periodFrom', $event)"
      @blur="$emit('change')"
    >
      <template #append>
        <q-icon name="event" class="cursor-pointer" role="button" tabindex="0" aria-label="Выбрать дату начала" @keydown.enter.prevent="$event.currentTarget.click()" @keydown.space.prevent="$event.currentTarget.click()">
          <q-popup-proxy cover transition-show="scale" transition-hide="scale">
            <q-date
              :model-value="periodFrom"
              :mask="quasarDateMask"
              @update:model-value="$emit('update:periodFrom', $event); $emit('change')"
            />
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>
    <q-input
      dense
      outlined
      :model-value="periodTo"
      label="По дату"
      :mask="dateInputMask"
      :rules="dateRules"
      data-testid="saved-report-period-to"
      @update:model-value="$emit('update:periodTo', $event)"
      @blur="$emit('change')"
    >
      <template #append>
        <q-icon name="event" class="cursor-pointer" role="button" tabindex="0" aria-label="Выбрать дату окончания" @keydown.enter.prevent="$event.currentTarget.click()" @keydown.space.prevent="$event.currentTarget.click()">
          <q-popup-proxy cover transition-show="scale" transition-hide="scale">
            <q-date
              :model-value="periodTo"
              :mask="quasarDateMask"
              @update:model-value="$emit('update:periodTo', $event); $emit('change')"
            />
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>
  </div>
</template>

<script>
export default {
  name: 'SavedReportFilters',
  emits: ['change', 'update:periodFrom', 'update:periodTo', 'update:reportType'],
  props: {
    reportType: {
      type: Object,
      required: true
    },
    reportTypeOptions: {
      type: Array,
      required: true
    },
    periodFrom: {
      type: String,
      required: true
    },
    periodTo: {
      type: String,
      required: true
    },
    dateInputMask: {
      type: String,
      required: true
    },
    quasarDateMask: {
      type: String,
      required: true
    },
    dateRules: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.saved-report-filters {
  display: grid;
  min-width: min(100%, 42rem);
  grid-template-columns: minmax(12rem, 1.4fr) repeat(2, minmax(9rem, 1fr));
  gap: var(--sid-space-2);
}

@media (max-width: 599px) {
  .saved-report-filters {
    min-width: 0;
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
